(() => {
  const selector = 'iframe[data-kairali-youtube-src]';

  const enhance = (iframe) => {
    if (iframe.dataset.kairaliYoutubeReady === 'true') return;

    const source = iframe.dataset.kairaliYoutubeSrc;
    if (!source || !/^https:\/\/(www\.)?youtube(?:-nocookie)?\.com\/embed\//i.test(source)) return;

    iframe.dataset.kairaliYoutubeReady = 'true';
    const title = iframe.getAttribute('title')?.trim() || 'YouTube video';
    const width = Number.parseFloat(iframe.getAttribute('width')) || 16;
    const height = Number.parseFloat(iframe.getAttribute('height')) || 9;

    const container = document.createElement('div');
    container.className = 'kairali-deferred-youtube';
    container.style.aspectRatio = `${width} / ${height}`;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'kairali-deferred-youtube__button';
    button.setAttribute('aria-label', `Play ${title} (loads YouTube)`);
    button.innerHTML = '<span class="kairali-deferred-youtube__play" aria-hidden="true">▶</span><span><strong>Play video</strong><small>Loads YouTube after you choose to play</small></span>';

    iframe.hidden = true;
    iframe.parentNode.insertBefore(container, iframe);
    container.append(button, iframe);

    button.addEventListener('click', () => {
      iframe.hidden = false;
      iframe.setAttribute('src', source);
      iframe.setAttribute('title', title);
      iframe.setAttribute('loading', 'eager');
      iframe.setAttribute('allow', iframe.getAttribute('allow') || 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      button.remove();
      iframe.focus();
    }, { once: true });
  };

  const initialize = (root = document) => root.querySelectorAll(selector).forEach(enhance);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
